<template>
  <div>
    <v-data-table
      :items="items"
      :loading="loading"
      :server-items-length="total"
      :headers="headers"
      :options.sync="options"
      :items-per-page="10"
      disable-sort
      :footer-props="{
        'items-per-page-options': [10, 20, 50],
        showFirstLastPage: true,
      }"
    >
      <template #[`item.subject`]="{ item }">
        {{ get(item, 'class.academicLevel.title') }}
      </template>

      <template #[`item.class`]="{ item }">
        <router-link :to="`/class/${get(item, 'class.id')}`" class="text-decoration-none">
          {{ get(item, 'class.title') }}
        </router-link>
      </template>

      <template #[`item.teachers`]="{ item }">
        <div v-for="(teacher, index) in get(item, 'class.teachers', [])" :key="teacher.id">
          <router-link :to="`/teacher/${teacher.id}`" class="text-decoration-none">
            {{ teacher.name }}
          </router-link>
          <template v-if="index < get(item, 'class.teachers', []).length - 1">, </template>
        </div>
      </template>

      <template #[`item.location`]="{ item }">
        {{ get(item, 'class.department.title') }}
      </template>

      <template #[`item.price`]="{ item }">
        <template v-if="item.amount">
          {{ Number(item.amount).toLocaleString() }} VND
          {{ formatPriceType(item.priceType) }}
        </template>
        <template v-else> Chưa cấu hình </template>
      </template>

      <template #[`item.paymentType`]="{ item }">
        {{ formatPaymentType(item.paymentType) }}
      </template>

      <template #[`item.actualPaymentPeriod`]="{ item }">
        <v-icon @click="$refs['dialog-detail-period'].openDialog(item)">mdi-eye</v-icon>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <DialogDetailPeriod ref="dialog-detail-period" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash-es'
import DialogDetailPeriod from './DialogDetailPeriod.vue'
export default {
  name: 'TuitionFeeClassSetup',
  components: {
    DialogDetailPeriod,
  },
  data() {
    return {
      get,
      options: {},
      headers: [
        { text: 'Bộ môn', value: 'subject' },
        { text: 'Lớp', value: 'class' },
        { text: 'Giáo viên', value: 'teachers' },
        { text: 'Cơ sở', value: 'location' },
        { text: 'Mức học phí', value: 'price' },
        { text: 'Hình thức thu', value: 'paymentType' },
        { text: 'Kỳ đóng thực tế', value: 'actualPaymentPeriod', align: 'center' },
        { text: 'Hành động', value: 'actions', align: 'center' },
      ],
    }
  },

  computed: {
    ...mapState('tuitionFeeClassSetup', ['items', 'total', 'loading']),
  },

  watch: {
    options: {
      handler() {
        this.fetchItems()
      },
      deep: true,
    },
  },

  created() {
    this.fetchItems()
  },

  methods: {
    formatPriceType(type) {
      const types = {
        per_session: '/ buổi',
        monthly: '/ tháng',
        quarterly: '/ 3 tháng',
        course: '/ khóa',
      }
      return types[type] || type
    },

    formatPaymentType(type) {
      const types = {
        pre: 'Thu trước',
        post_actual: 'Thu sau (theo thực tế)',
        post_expected: 'Thu sau (theo dự kiến)',
      }
      return types[type] || type
    },

    fetchItems() {
      const { page, itemsPerPage } = this.options

      const params = {
        _start: ((page || 1) - 1) * (itemsPerPage || 10),
        _limit: itemsPerPage || 10,
      }

      this.$store.dispatch('tuitionFeeClassSetup/fetchItems', params)
    },

    deleteItem(item) {
      this.$dialog.confirm({
        title: 'Xác nhận xóa',
        text: 'Bạn có chắc chắn muốn xóa học phí này?',
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          try {
            await this.$store.dispatch('tuitionFeeClassSetup/remove', item.id)
            this.$toast.success('Xóa học phí thành công')
            this.fetchItems()
          } catch (error) {
            this.$toast.error('Xóa học phí thất bại')
          }
        },
      })
    },
  },
}
</script>
